import { createRouter, createWebHashHistory } from 'vue-router';
import ResetPin from '../views/ResetPin';
import EmailSignIn from '@/views/EmailSignIn';

const routes = [
    {
        path: '/',
        redirect: '/sign-in'
    },
    {
        path: '/sign-in',
        name: 'SignIn',
        component: () => import("../views/SignIn.vue"),
        meta: {
            isSignIn: true
        },
        beforeEnter: () => {
            return true;
        }
    },
    {
        path: '/email-sign-in',
        name: 'EmailSignIn',
        component: EmailSignIn,
        meta: {
            isSignIn: true
        }
    },
    {
        path: '/reset-pin',
        name: 'ResetPin',
        component: ResetPin
    },
    {
        path: '/new-account',
        name: 'NewAccount',
        component: () => import('@/views/NewAccount.vue'),
        beforeEnter: () => {
            localStorage.clear();

            return true;
        }
    },
    {
        path: '/switch-account/:module/:valid',
        // component: () => import('@/views/SwitchAccount'),
        name: 'SWITCH_ACCOUNT',
        redirect: {
            name: 'SignIn'
        }
    }
    // {
    //     path: '/:pathMatch(.*)*',
    //     redirect: '/sign-in'
    // },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
